import _ from 'lodash'
import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { 
    completeNewServiceStep, 
    selectNewServiceStep, 
    uncheckNewServiceStep,
    getCountriesList, 
    getZonesByCountry, 
    unselectCountry } from 'actions/shared'
import { NEW_SERVICE_VIEWS, SIGNUP } from 'constants/index'
import MultipleSelect from 'components/atoms/inputs/multiple_select'
import Button from 'components/atoms/buttons/solid'
import * as routes from 'constants/routes'
import { capitalizeOnlyFirstLetter, localeSortArrayBy } from 'helpers/index'

class NewServiceZones extends Component{
    constructor(props){
        super(props)
        this.state = { selectCountriesValue: this.props.initialCountries }
        this.updateValue = this.updateValue.bind(this)
        this.renderFieldsForZones = this.renderFieldsForZones.bind(this)
        this.maxLength3 = this.maxLength3.bind(this)
        this.minLength1 = this.minLength1.bind(this)
    }

    componentDidMount(){
        this.props.getCountriesList()
    }

    onSubmit(values){
        this.props.completeNewServiceStep(NEW_SERVICE_VIEWS.zones)
        this.props.selectNewServiceStep(NEW_SERVICE_VIEWS.availability)
        this.props.history.push(routes.ARTIST_JOB_SERVICES_NEW)
    }

    maxLength3(values = []){
        this.props.uncheckNewServiceStep(NEW_SERVICE_VIEWS.zones)
        return values.length > 3 ? 'No puedes elegir más de 3 opciones' : undefined
    }
    
    minLength1(values = []){
        this.props.uncheckNewServiceStep(NEW_SERVICE_VIEWS.zones)
        return values.length < 1 ? 'Tienes que elegir al menos una opción' : undefined
    }

    updateValue(newValue) {
        let difference = this.props.initialCountries.filter(x => !newValue.includes(x))
        this.setState({ selectCountriesValue: newValue })
        
        if (difference.length === 0)
            this.props.getZonesByCountry(newValue[newValue.length-1].value)
        else {
            this.props.unselectCountry(difference[0].value)
            this.props.change(`presence-for-${difference[0].value}`, [])
        }
    }

    renderFieldsForZones(zonesByCountry){
        if (Object.keys(zonesByCountry).length > 0){
            let zonesArrayOptions = []
            
            return (
                _.map(zonesByCountry, (zones, country) => {

                    zonesArrayOptions = _.map(zones, (zoneValue, zoneId) => ({ value:zoneId, label:capitalizeOnlyFirstLetter(zoneId) }) )
                    zonesArrayOptions = localeSortArrayBy(zonesArrayOptions, 'value')
                    return(
                        <div className='my-2' key={country}>
                            <p>Zonas para {country}</p>
                            <Field
                                name={`presence-for-${country}`}
                                type='select'
                                selectType={SIGNUP.SELECT_TYPE_ZONES}
                                placeholder={`Selecciona 3 zonas para ${country}`}
                                options={zonesArrayOptions}
                                validate={[this.maxLength3,this.minLength1]}
                                component={MultipleSelect}
                            />
                        </div>
                    )
                })
            )
        }
        else{
            console.log('No hay zonas')
        }
    }

    render(){
        const { handleSubmit } = this.props
        return (
            <div className='container mt-5'>
                <h4 className='text-secondary'>Zonas de servicio</h4>
                <p>Puedes delimitar las zonas de tu servicio.</p>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} className='p-2'>
                    <Field
                        name="countries-presence"
                        type='select'
                        selectType={SIGNUP.SELECT_TYPE_COUNTRIES}
                        placeholder='Selecciona 3 países'
                        options={this.props.countries}
                        component={MultipleSelect}
                        validate={[this.maxLength3,this.minLength1]}
                        updateValue={this.updateValue}
                    />

                    <div className='w-100 my-3'></div>
                    {this.renderFieldsForZones(this.props.zonesByCountry)}
            
                    <div className='my-5 d-flex justify-content-center'>
                        <Button 
                            type='submit' 
                            color='primary' 
                            text='Guardar'
                        />
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps({ shared, form }){
    let initialCountries = []
    if(form.createNewServiceWizard && form.createNewServiceWizard.values)
        if(typeof form.createNewServiceWizard.values['countries-presence'] !== 'undefined')
            initialCountries = form.createNewServiceWizard.values['countries-presence']

    let countriesArray = []
    let { countries, zonesByCountry } = shared

    countries.forEach( country => countriesArray.push({ value:country.name, label:country.name }) )
    
    return { countries: countriesArray, zonesByCountry, initialCountries }
}

NewServiceZones = reduxForm({
    form: 'createNewServiceWizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(NewServiceZones)
  
  NewServiceZones = connect(
    mapStateToProps,
    { 
        completeNewServiceStep, 
        selectNewServiceStep, 
        uncheckNewServiceStep,
        getCountriesList, 
        getZonesByCountry, 
        unselectCountry,
        change }
  )(NewServiceZones)
  
  export default withRouter(NewServiceZones)